import React, { useState, useEffect } from 'react';
import { styled } from "../../../stitches.config";
import Slider from "react-slick";
import Box from '../Box'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons 
import background from '../../../assets/img/mamadu/santander/bg-desktop.png'
import backgroundMobile from '../../../assets/img/mamadu/santander/bg-mobile.png'
import ArrowLeft from '../../../assets/img/mamadu/carrefour/ArrowLeft.png'
import ArrowRight from '../../../assets/img/mamadu/carrefour/ArrowRight.png'

import img1 from '../../../assets/img/mamadu/santander/img-3.jpeg';
import img2 from '../../../assets/img/mamadu/santander/img-2.jpg';
import img3 from '../../../assets/img/mamadu/santander/img-4.jpeg';
import img4 from '../../../assets/img/mamadu/santander/img-2.jpeg';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowRight} />
        </CustomArrow>
    );
}


function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowLeft} />
        </CustomArrow>
    );
}

const config = {
    settings: {
        b1: {
            title: "",
            description: "Psycholog zdradza cechy ludzi przedsiębiorczych. Sprawdź, czy wspierasz ich rozwój u swojego dziecka",
            img: img1,
            link: "https://mamadu.pl/167512,cechy-ludzi-przedsiebiorczych-okiem-psychologa-czy-ma-je-twoje-dziecko",
        },
        b2: {
            title: "",
            description: "Przygotowują do życia, a wciąż nie ma ich w szkołach. Nauczyciel o brakujących przedmiotach",
            img: img2,
            link: "https://mamadu.pl/167689,tych-przedmiotow-brakuje-w-szkolach-nauczyciel-o-brakujacych-przedmiotach",
        },
        b3: {
            title: "",
            description: "Drogo, znaczy ile? Czy i jak rozmawiać z dziećmi o domowym budżecie?",
            img: img3,
            link: "https://mamadu.pl/168076,drogo-znaczy-ile-czy-i-jak-rozmawiac-z-dziecmi-o-finansowych",
        },
        b4: {
            title: "",
            description: "W wielu domach to nadal temat tabu. Pytamy mamy, jak rozmawiają z dziećmi o pieniądzach",
            img: img4,
            link: "https://mamadu.pl/167587,jak-rozmawiac-z-dziecmi-o-pieniadzach-mamy-zdradzaja-swoje-sposoby",
        },
    }
}

const shuffleCards = (number) => (cards) => {
    const array = Object.keys(cards).map(k => cards[k]);
    let currentIndex = array.length, randomIndex;

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    const obj = array.reduce((acc, curr, i) => (acc[`b${i + number}`] = curr, acc), {})

    return obj
}

const shuffleCardsAll = shuffleCards(1)

export default props => {
    const [allCards] = useState(() => shuffleCardsAll(config.settings))
    useEffect(() => {
        console.log({ allCards })
    })
    const settings = {
        infinite: true,
        dots: true,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1370,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    arrows: true,
                    dots: true,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "70px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "20px",
                }
            }
        ]
    };
    return (
        <Section>
            <Wrapper>
                <CarouselWrapper>
                    <Slider {...settings}>
                        <Box {...props}
                            id="b1"
                            type="ASpecialSantander"
                            settings={allCards.b1}
                        />
                        <Box {...props}
                            id="b2"
                            type="ASpecialSantander"
                            settings={allCards.b2}
                        />
                        <Box {...props}
                            id="b3"
                            type="ASpecialSantander"
                            settings={allCards.b3}
                        />
                        <Box {...props}
                            id="b4"
                            type="ASpecialSantander"
                            settings={allCards.b4}
                        />
                    </Slider>
                </CarouselWrapper>
            </Wrapper>
        </Section>
    );
}

const CustomArrow = styled("div", {
    "img": {
        width: "43px",
        height: "43px",
        margin: "auto",
        position: "absolute",
        top: "-10px",
        left: "0"
    }
})

const CarouselWrapper = styled("div", {
    marginBottom: "55px",
    overflow: "visible",
    ".slick-list": {
        marginBottom: "50px",
        "@bp4": {
            marginBottom: "0px",
            padding: "10px 0px"
        }
    },
    ".slick-slide": {
        "& > div": {
            display: "grid",
            placeItems: "center"
        }
    },
    ".slick-arrow": {
        zIndex: 10
    },
    ".slick-prev": {
        left: "410px",
        top: "382px",
        "@bp4": {
            left: "530px"
        }
    },
    ".slick-next": {
        right: "440px",
        top: "382px",
        "@media only screen and (min-width: 1370px)": {
            right: "560px"
        }
    },
    ".slick-dots": {
        bottom: "-35px",
        li: {
            margin: "0",
            width: "18px",
            height: "9px",
            "&.slick-active": {
                button: {
                    "&:before": {
                        color: "#ec0000",
                        "@bp4": {
                            borderRadius: "10px"
                        }
                    }
                }
            },
            button: {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "white",
                    opacity: 1,
                    "@bp4": {
                        borderWidth: "0px",
                        borderRadius: "10px"
                    }
                }
            }
        }
    }
});

const Section = styled("div", {
    overflow: "hidden",
    width: "100%",
    backgroundImage: `url("${backgroundMobile}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    marginTop: "20px",
    marginBottom: "10px",
    paddingBottom: "1px",
    backgroundColor: "#deedf1",
    paddingTop: "130px",
    "@bp4": {
        backgroundPosition: "center",
        backgroundSize: "cover top",
        position: "relative",
        marginTop: "10px",
        paddingTop: "120px",
        backgroundImage: `url("${background}")`
    }
})

const Wrapper = styled("div", {
    width: "100%",
    maxWidth: "1266px",
    margin: "0 auto",
    "@bp4": {
        maxWidth: "990px"
    },
    "@media only screen and (min-width: 1370px)": {
        maxWidth: "1266px"
    }
})